import {
  CalendarDays, Clock, Target, TrendingDown, TrendingUp, Zap, Scale, Timer, PenLine,
} from "lucide-react";
import { fmtHoras } from "@/lib/format";

function StatCard({ icon: Icon, label, value, sub, accent, negative }) {
  return (
    <div className={`rounded-2xl border bg-white p-4 shadow-sm ${accent}`}>
      <div className="flex items-start justify-between gap-2">
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${negative ? "bg-rose-100 text-rose-600" : "bg-indigo-100 text-indigo-600"}`}>
          <Icon className="h-5 w-5" strokeWidth={1.75} />
        </div>
        {sub && <span className="text-[10px] font-medium text-zinc-400">{sub}</span>}
      </div>
      <p className="mt-3 text-[11px] font-semibold uppercase tracking-wide text-zinc-500">{label}</p>
      <p className={`mt-0.5 text-xl font-semibold ${negative ? "text-rose-600" : "text-zinc-900"}`}>{value}</p>
    </div>
  );
}

export default function BalanceHorasCards({ usuario, periodo }) {
  if (!usuario) return null;
  const saldoNeg = (usuario.saldo_segundos || 0) < 0;
  const saldoPos = (usuario.saldo_segundos || 0) > 0;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-3">
        <StatCard
          icon={CalendarDays}
          label="Días trabajados"
          value={usuario.dias_trabajados ?? 0}
          sub={periodo}
          accent="border-emerald-100"
        />
        <StatCard
          icon={Clock}
          label="Horas trabajadas"
          value={fmtHoras(usuario.segundos || 0)}
          accent="border-sky-100"
        />
        <StatCard
          icon={Target}
          label="Horas previstas"
          value={fmtHoras(usuario.segundos_previstos || 0)}
          accent="border-violet-100"
        />
        <StatCard
          icon={saldoNeg ? TrendingDown : TrendingUp}
          label="Bolsa / saldo"
          value={`${saldoNeg ? "−" : saldoPos ? "+" : ""}${fmtHoras(Math.abs(usuario.saldo_segundos || 0))}`}
          negative={saldoNeg}
          accent={saldoNeg ? "border-rose-100" : "border-green-100"}
        />
        <StatCard
          icon={Zap}
          label="Horas extra"
          value={fmtHoras(usuario.extra_segundos || 0)}
          accent="border-amber-100"
        />
        <StatCard
          icon={Scale}
          label="Compensadas"
          value={fmtHoras(usuario.compensado_segundos || 0)}
          accent="border-fuchsia-100"
        />
        <StatCard
          icon={Timer}
          label="Extra pendiente"
          value={fmtHoras(usuario.extra_pendiente_segundos || 0)}
          accent="border-orange-100"
        />
        <StatCard
          icon={PenLine}
          label="Fichajes manuales"
          value={usuario.manuales ?? 0}
          accent="border-zinc-200"
        />
      </div>
      {usuario.sesion_abierta && (
        <p className="flex items-center gap-2 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-800">
          <span className="inline-block h-2 w-2 animate-pulse rounded-full bg-amber-500" />
          Tienes una sesión de fichaje abierta en este periodo.
        </p>
      )}
    </div>
  );
}
